import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-grow: 1;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;
